export const atomsKeys = {
  OPEN_ADD_SERVICE_MODAL: "open_service_modal",
  OPEN_EDIT_SERVICE_MODAL: "edit_service_modal"
};
